import React from 'react';
import YouTubeInput from '../Video/YouTubeInput';

const HeroSection = ({
  // YouTube Input props
  inputUrl,
  setInputUrl,
  inputTitle,
  loading,
  error,
  handleAnalyzeClick,
  fetchYoutubeTitle,
  // Mobile detection
  isMobile
}) => {
  return (
    <YouTubeInput
      url={inputUrl}
      setUrl={setInputUrl}
      videoTitle={inputTitle}
      loading={loading}
      error={error}
      handleAnalyze={handleAnalyzeClick}
      fetchYoutubeTitle={fetchYoutubeTitle}
    />
  );
};

export default HeroSection; 